import {fetchCartList} from "@/api/cart.js";

export const getCartLength = () => {
  return fetchCartList().then(response => {
    const list = response.data;
    const cartLength = list.reduce((total, item) => {
      return total + item.quantity;
    }, 0);
    return cartLength;
  });
}
